<app-mb-card class="intro-card">
    <header>
        <h2>Bienvenido al gestor de compañías de mBase</h2>
        <p>Desde aquí podrás administrar las distintas compañías dadas de alta en el sistema mBase.</p>
    </header>
</app-mb-card>
<div class="stats-row">
    <app-mb-card class="kpi-card">
        <h5>Compañías (totales)</h5>
        <h2><span>{{companies}}</span></h2>
    </app-mb-card>
    <app-mb-card class="kpi-card">
        <h5>Compañías activas</h5>
        <h2><span>{{enabledCompanies}}</span></h2>
    </app-mb-card>
    <app-mb-card class="kpi-card">
        <h5>Compañías inactivas</h5>
        <h2><span>{{disabledCompanies}}</span></h2>
    </app-mb-card>
</div>
<div class="stats-row">
  <app-mb-card class="kpi-card">
    <h5>Licencias (totales)</h5>
    <h2><span>{{licenses}}</span></h2>
  </app-mb-card>
  <app-mb-card class="kpi-card">
    <h5>Licencias activas</h5>
    <h2><span>{{enabledLicenses}}</span></h2>
  </app-mb-card>
  <app-mb-card class="kpi-card">
    <h5>Licencias inactivas</h5>
    <h2><span>{{disabledLicenses}}</span></h2>
  </app-mb-card>
  <app-mb-card class="kpi-card">
    <h5>Licencias expiradas</h5>
    <h2><span>{{expiredLicenses}}</span></h2>
  </app-mb-card>
</div>
